module.exports = __webpack_public_path__ + "img/p1-cloud-l.0d6eea29.png";